//클라이언트 검색 대상
export enum ClientTarget {
    COMPANY_NAME = "companyName",
    BUSINESS_NUMBER = "businessNumber",
    ALL = "ALL"
}

//계약 상태
export enum ContractStatus {
    계약 = "계약",
    만료 = "만료",
    미계약 = "미계약",
    예정 = "예정"
}

//클라이언트 계약 정렬 기준
export enum ClientSort {
    //회사명
    COMPANY_ASC = "COMPANY_ASC",
    COMPANY_DESC = "COMPANY_DESC",
    //계약 시작일
    START_ASC = "START_ASC",
    START_DESC = "START_DESC",
    //계약 만료일
    EXPIRE_ASC = "EXPIRE_ASC",
    EXPIRE_DESC = "EXPIRE_DESC",
    //작업자 단가
    COST_ASC = "COST_ASC",
    COST_DESC = "COST_DESC",
}

//클라이언트 계정 상태
export enum ClientStatus {
    대기 = "대기",
    승인 = "승인",
    반려 = "반려",
    만료 = "만료"
}

//결제 여부
export enum PaymentStatus {
    납부 = "납부",
    미납 = "미납"
}

//결제 정렬 기준
export enum PaymentSort {
    //회사명
    COMPANY_ASC = "COMPANY_ASC",
    COMPANY_DESC = "COMPANY_DESC",
    //결제일
    PAID_ASC = "PAID_ASC",
    PAID_DESC = "PAID_DESC",
    //결제액
    AMOUNT_ASC = "AMOUNT_ASC",
    AMOUNT_DESC = "AMOUNT_DESC",
    //주문명
    ORDER_ASC = "ORDER_ASC",
    ORDER_DESC = "ORDER_DESC",
}

//결제 검색 대상
export enum PaymentTarget {
    COMPANY_NAME = 'companyName',
    ORDER_NAME = 'orderName',
    ALL = 'ALL'
}

//세금계산서 정렬 기준, API 연결 후 수정 예정
export enum InvoiceSort {
    COMPANY_ASC = "COMPANY_ASC",
    COMPANY_DESC = "COMPANY_DESC",
    CREATE_ASC = "CREATE_ASC",
    CREATE_DESC = "CREATE_DESC",
    ISSUE_ASC = "ISSUE_ASC",
    ISSUE_DESC = "ISSUE_DESC",
    TOTAL_ASC = "TOTAL_ASC",
    TOTAL_DESC = "TOTAL_DESC"
}

//정기 세금계산서 발행 정렬 기준
export enum RegularInvoiceSort {
    COMPANY_ASC = "COMPANY_ASC",
    COMPANY_DESC = "COMPANY_DESC",
    AMOUNT_ASC = "AMOUNT_ASC",
    AMOUNT_DESC = "AMOUNT_DESC"
}

export enum RegularInvoiceTarget {
    COMPANY_NAME = 'companyName',
    ALL = 'ALL'
}

//세금계산서 검색 기준, API 연결 후 수정 예정
export enum InvoiceTarget {
    COMPANY_NAME = 'companyName',
    EMAIL = 'email',
    ALL = 'ALL'
}

//결제방법
export enum PaymentType {
    계좌이체 = '계좌이체',
    신용카드 = '신용카드',
    간편결제 = '간편결제',
    정기자동결제 = '정기자동결제'
}

export enum InvoiceStatus {
    임시저장 = '임시저장',
    발행 = '발행',
    전송전 = '전송전',
    전송성공 = '전송성공',
    전송실패 = '전송실패',
    발행취소 = '발행취소'
}